import { gql } from '@apollo/client';

export const REACTIVATE_PATIENT = gql`
  mutation ReactivatePatient($record: ActivatePatientInput!) {
    user {
      patientUser {
        activatePatient(record: $record) {
          ok
          error {
            message
            code
          }
          resultId
          result {
            id
            name {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
